import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Terms from "../views/Terms.vue";
import Policy from "../views/Policy.vue";
import UserTable from "../views/admin/users/Tables.vue";
import UserCreate from "../views/admin/users/Create.vue";
import ModelsTable from "../views/admin/models/Tables.vue";
import ModelsCreate from "../views/admin/models/Create.vue";
import InventoryTable from "../views/admin/inventory/Tables.vue";
import PaymentTable from "../views/admin/payments/Tables.vue";
import ProductionTable from "../views/admin/production/Tables.vue";
import ProductionCreate from "../views/admin/production/Create.vue";
import OperationsTable from "../views/admin/operations/Tables.vue";

import ReportTable from "../views/admin/reports/Tables.vue";
import SuppliesTable from "../views/admin/supplies/Tables.vue";
import SuppliesCreate from "../views/admin/supplies/Create.vue";
import PurchasesTable from "../views/admin/purchases/Tables.vue";
import PurchasesCreate from "../views/admin/purchases/Create.vue";
import NominaTable from "../views/admin/nomina/Tables.vue";
import NominaPaymentsTable from "../views/admin/nomina/Payments.vue";
import NominaProductionsTable from "../views/admin/nomina/Production.vue";
import Login from "../views/auth/Login.vue";
import Register from "../views/auth/Register.vue";
import RemissionsTable from "../views/admin/remissions/Table.vue";
import RemissionsCreate from "../views/admin/remissions/Create.vue";
import Settings from "../views/admin/settings/Settings.vue";
import Pos from "../views/admin/pos/Pos.vue";
import PosTicket from "../views/admin/pos/PosTicket.vue";
import UserProfile from "../views/examplesApi/UserProfile/EditUserProfile.vue";
import ForgotPassword from "../views/auth/ForgotPassword.vue";
import ResetPassword from "../views/auth/ResetPassword.vue";
import auth from "../middleware/auth";
import guest from "../middleware/guest";
import operator from "../middleware/operator";
import success from "../views/success.vue";
import fail from "../views/fail.vue";
import OperadorDashboard from "../views/operador/Dashboard.vue";
import ProductionUserTable from "../views/operador/production-user/Tables.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      middleware: auth,
      routeName: "Inicio",
    },
  },
  {
    path: "/pos",
    name: "POS",
    routeName: "POS",
    component: Pos,
    meta: {
      middleware: auth,
      routeName: "POS",
    },
  },
  {
    path: "/pos/ticket",
    name: "POS Ticket",
    routeName: "Ticket POS",
    component: PosTicket,
    meta: {
      middleware: auth,
      routeName: "Ticket POS",
    },
  },
  {
    path: "/users",
    name: "Users",
    routeName: "Usuarios",
    component: UserTable,
    meta: {
      middleware: auth,
      routeName: "Usuarios",
    },
  },
  {
    path: "/users/create",
    name: "User Create",
    routeName: "Crear Usuarios",
    component: UserCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Usuario",
    },
  },
  {
    path: "/models",
    name: "Models",
    routeName: "Modelos",
    component: ModelsTable,
    meta: {
      middleware: auth,
      routeName: "Modelos",
    },
  },
  {
    path: "/models/create",
    name: "Models Create",
    routeName: "Crear Modelo",
    component: ModelsCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Modelo",
    },
  },
  {
    path: "/inventory",
    name: "Inventory",
    routeName: "Inventario",
    component: InventoryTable,
    meta: {
      middleware: auth,
      routeName: "Inventario",
    },
  },
  {
    path: "/nomina",
    name: "Nomina",
    routeName: "Nomina",
    component: NominaTable,
    meta: {
      middleware: auth,
      routeName: "Nomina",
    },
  },
  {
    path: "/nomina-payments",
    name: "Nomina Payments",
    routeName: "Nomina-payments",
    component: NominaPaymentsTable,
    props: true,
    meta: {
      middleware: auth,
      routeName: "Pagos Nomina",
    },
  },
  {
    path: "/nomina-productions",
    name: "Nomina Productions",
    routeName: "Trabajos realizados",
    component: NominaProductionsTable,
    props: true,
    meta: {
      middleware: auth,
      routeName: "Trabajos realizados",
    },
  },
  {
    path: "/production",
    name: "Production",
    routeName: "Producción",
    component: ProductionTable,
    meta: {
      middleware: auth,
      routeName: "Producción",
    },
  },

  {
    path: "/operations",
    name: "Operations",
    routeName: "Operaciones",
    component: OperationsTable,
    meta: {
      middleware: auth,
      routeName: "Operaciones",
    },
  },

  {
    path: "/production/create",
    name: "Production Create",
    routeName: "Crear Producción",
    component: ProductionCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Producción",
    },
  },
  {
    path: "/supplies",
    name: "Supplies",
    routeName: "Inventario",
    component: SuppliesTable,
    meta: {
      middleware: auth,
      routeName: "Inventario",
    },
  },
  {
    path: "/supplies/create",
    name: "Supplies Create",
    routeName: "Crear inventario",
    component: SuppliesCreate,
    meta: {
      middleware: auth,
      routeName: "Crear inventario",
    },
  },
  {
    path: "/purchases",
    name: "Purchases",
    routeName: "Compras",
    component: PurchasesTable,
    meta: {
      middleware: auth,
      routeName: "Compras",
    },
  },
  {
    path: "/reports",
    name: "Reports",
    routeName: "Reportes",
    component: ReportTable,
    meta: {
      middleware: auth,
      routeName: "Reportes",
    },
  },
  {
    path: "/purchases/create",
    name: "Purchases Create",
    routeName: "Crear Compra",
    component: PurchasesCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Compras",
    },
  },
  {
    path: "/settings",
    name: "Settings",
    routeName: "Configuración",
    component: Settings,
    meta: {
      middleware: auth,
      routeName: "Configuración",
    },
  },
  {
    path: "/user-profile",
    name: "User Profile",
    routeName: "Perfil",
    component: UserProfile,
    meta: {
      middleware: auth,
      routeName: "Perfil",
    },
  },
  {
    path: "/register",
    name: "Register",
    routeName: "Registro",
    component: Register,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/remissions",
    name: "Remissions",
    routeName: "Remisiones",
    component: RemissionsTable,
    meta: {
      middleware: auth,
      routeName: "Remisiones",
    },
  },
  {
    path: "/remissions/create",
    name: "Remissions Create",
    routeName: "Crear Remision",
    component: RemissionsCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Remision",
    },
  },
  {
    path: "/password/forgot",
    name: "Forgot Password",
    routeName: "Olvido clave",
    component: ForgotPassword,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/password/reset",
    name: "Reset Password",
    routeName: "Cambiar clave",
    component: ResetPassword,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/payment",
    name: "Payment",
    routeName: "Payment",
    component: PaymentTable,
    meta: {
      middleware: auth,
      routeName: "Pagos",
    },
  },
  {
    path: "/terms",
    name: "Terms",
    routeName: "Terminos",
    component: Terms,
  },
  {
    path: "/policy",
    name: "Policy",
    routeName: "Politicas",
    component: Policy,
  },
  {
    path: "/success",
    name: "Success",
    routeName: "Exito",
    component: success,
  },
  {
    path: "/fail",
    name: "Fail",
    routeName: "Fallo",
    component: fail,
  },
  // Rutas para operador
  {
    path: "/operador/dashboard",
    name: "Operador Dashboard",
    routeName: "Dashboard Operador",
    component: OperadorDashboard,
    meta: {
      middleware: [auth, operator],
      routeName: "Dashboard",
    },
  },
  {
    path: "/operador/tareas",
    name: "Operador Tasks",
    routeName: "Mis Tareas",
    component: ProductionUserTable,
    meta: {
      middleware: [auth, operator],
      routeName: "Mis Tareas",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Creates a nextMiddleware() function which not only
// runs the default next() callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default next() callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router next() callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // nextMiddleware() callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, to, router };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
